import FadeInSection from '../FadeInSection'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolder, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { faGithub } from '@fortawesome/free-brands-svg-icons'
import './index.scss'

const linkIcon = (label) => {
  if (label === 'Open') return faArrowUpRightFromSquare
  return faGithub
}

const projects = [
  {
    id: 1,
    title: 'Scoop',
    badge: 'AI · Mobile',
    description:
      'AI-powered app that transcribes short-form videos into text using LLMs, then categorises content' +
        ' intelligently' +
        ' (recipes, lifestyle, beauty) and resurfaces saved videos via contextual reminders. Currently in closed beta on Android & iOS.',
    techStack: 'Kotlin · Jetpack Compose · Swift · Java Spring Boot · PostgreSQL · RAG· LangChain' +
        ' Engineering',
    links: [
      { label: 'Android', href: 'https://github.com/akshataxx/TranscribeAssistant' },
      { label: 'iOS', href: 'https://apps.apple.com/us/app/scooop/id6760988394' },
      { label: 'Backend', href: 'https://github.com/akshataxx/content-categorise' },
    ],
  },
  {
    id: 2,
    title: 'Fuel Price Prediction',
    description:
      'A machine-learning model that predicts fuel prices using a custom bidirectional RNN–LSTM architecture.',
    techStack: 'Python · Jupyter Notebook · TensorFlow · Bidirectional RNN–LSTM · Predictive Analytics',
    links: [
      { label: 'GitHub', href: 'https://github.com/akshataxx/Fuel-Price-Prediction' },
    ],
  },
  {
    id: 3,
    title: 'FlightPub',
    description:
      'A full-stack flight booking app with search, filtering, and booking management.',
    techStack: 'React · Node.js · Express · MongoDB · Jest',
    links: [
      { label: 'GitHub', href: 'https://github.com/akshataxx/flightpub' },
    ],
  },
  {
    id: 4,
    title: 'IT Service Portal',
    description:
      'An enterprise IT service management portal with ticketing, user auth, and an admin dashboard.',
    techStack: 'Java · JSP · JavaScript · HTML · CSS · SQL',
    links: [
      { label: 'GitHub', href: 'https://github.com/akshataxx/SENG2050/tree/master' },
    ],
  },
  {
    id: 5,
    title: 'Software Quality Parser',
    description:
      'A Java parser that analyses source files and measures software quality using metrics such as Halstead complexity and the Fog index.',
    techStack: 'Java · Maven · Spoon · Java Parser · Halstead Complexity · Fog Index',
    links: [
      { label: 'GitHub', href: 'https://github.com/akshataxx/Parser-to-measure-software-quality' },
    ],
  },
  {
    id: 6,
    title: 'Maze Generator',
    description:
      'A maze generator and solver using Depth-First Search with animated visual output.',
    techStack: 'Java · DFS Algorithm',
    links: [
      { label: 'GitHub', href: 'https://github.com/akshataxx/Algorithms' },
    ],
  },
]

const Portfolio = () => {
  return (
    <section id="portfolio" className="portfolio-section">
      <FadeInSection>
        <div className="section-header">
          <span className="section-title">/ projects</span>
        </div>
      </FadeInSection>

      <ul className="projects-grid">
        {projects.map((project, i) => (
          <FadeInSection key={project.id} delay={`${i * 100}ms`}>
            <li className={`project-card${project.badge ? ' project-card--featured' : ''}`}>
              <div className="card-top">
                <FontAwesomeIcon icon={faFolder} className="folder-icon" />
                <div className="card-links">
                  {project.links.map((link) => (
                    <a
                      key={link.label}
                      href={link.href}
                      target="_blank"
                      rel="noreferrer"
                      title={link.label}
                    >
                      <FontAwesomeIcon icon={linkIcon(link.label)} />
                      {project.links.length > 1 && (
                        <span className="link-label">{link.label}</span>
                      )}
                    </a>
                  ))}
                </div>
              </div>
              <div className="card-title">
                {project.title}
                {project.badge && (
                  <span className="card-badge">{project.badge}</span>
                )}
              </div>
              <div className="card-desc">{project.description}</div>
              <div className="card-tech">{project.techStack}</div>
            </li>
          </FadeInSection>
        ))}
      </ul>
    </section>
  )
}

export default Portfolio
